var map = {
	"./B10-topic-selector.json": 836,
	"./B16-filter.json": 837,
	"./B23-news-results.json": 838,
	"./C2-search-results.json": 839,
	"./C3-filter.json": 840,
	"./D3-sample-cart.json": 841,
	"./form-modal-data.json": 842,
	"./main-navigation.json": 843,
	"./search-suggestions.json": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 835;